import { Box } from "@mui/material";
import { IconChevronLeft } from "@tabler/icons-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";
import { ROUTES } from "../../constants/routes";
import { useToast } from "../../contexts/ToastContext";

const EarningsAndPayouts = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleBack = () => {
    navigate(ROUTES.PAYMENTS);
  };

  const handleSetupPayout = () => {
    navigate(ROUTES.SETUP_PAYOUT);
  };

  const fetchPayoutSummary = async () => {
    try {
      // const response = await apiService.fetchPayoutSummary();
      // console.log("Payout Summary: ", response);
    } catch (error) {
      showToast(error.error, "error");
    }
  };

  useEffect(() => {
    fetchPayoutSummary();
  }, []);

  return (
    <>
      {/* Responsive Back Button and Header */}
      <Box sx={{ mb: 3, display: { xs: "block", md: "none" } }}>
        <Button variant="back" onClick={handleBack} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
        <Box
          onClick={handleBack}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            cursor: "pointer",
            color: "#1890FF",
            "&:hover": {
              color: "#40A9FF",
            },
          }}
        >
          <IconChevronLeft size={20} />
        </Box>
        <Text variant="pageHeader">Earnings and payouts</Text>
      </Box>

      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "8px",
          p: { md: 2 },
          border: { xs: "none", md: "1px solid #e5e5e5" },
        }}
      >
        {/* Payout Cards Container - horizontal layout */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: "24px",
            mb: "32px",
          }}
        >
          {/* Last Payout Card */}
          <Box
            sx={{
              flex: 1,
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              p: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text variant="paragraph3">Last payout</Text>
            <Text
              variant="paragraph"
              sx={{ fontSize: "24px", fontWeight: 600 }}
            >
              €0.00
            </Text>
            <Text variant="paragraph3" sx={{ color: "#A1A1A1" }}>
              date
            </Text>
          </Box>

          {/* Next Payout Card */}
          <Box
            sx={{
              flex: 1,
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              p: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text variant="paragraph3">Next payout</Text>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                mb: "4px",
              }}
            >
              <Text variant="paragraph" sx={{ fontSize: "16px" }}>
                Estimated amount
              </Text>
              <Text variant="paragraph" sx={{ fontSize: "16px" }}>
                →
              </Text>
              <Text
                variant="paragraph"
                sx={{ fontSize: "24px", fontWeight: 600 }}
              >
                €0.00
              </Text>
            </Box>
            <Text variant="paragraph3" sx={{ color: "#A1A1A1" }}>
              date
            </Text>
          </Box>
        </Box>

        {/* Setup Payout Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <Button
            variant="secondary"
            onClick={handleSetupPayout}
            sx={{
              minWidth: "200px",
            }}
          >
            Set up payout account
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default EarningsAndPayouts;
